import React from 'react'
import classNames from 'classnames'
import styles from './InputHelper.module.css'
import { default as generalStyle } from '../Theme/GeneralTheme.module.css'

function InputHelper({ icon = '', ...props }) {

  const { className, ...rest } = props;
  const childrenClassNames = classNames([generalStyle.general_style, styles.inputhelper], className)

  return (
    <div
      className={childrenClassNames}
      onClick={props.onClick}
      {...rest}
    >
      <span className={classNames([styles.inputhelpericon])}>{icon}</span>
      <span>{props.value}</span>
    </div>
  )
}

export { InputHelper }
